import { StyledLink } from './styles';

import { Box, Flex, Heading, Text } from '@chakra-ui/react';

interface TileItem {
    font?: 'smaller' | 'normal';
    title: string | JSX.Element;
    content?: string;
    logoImage?: {
        url: string;
        alt: string;
    };
    link?:
        | {
              label: string;
              href: string;
              target: string;
          }
        | '';
}

const TileItem: React.FC<TileItem> = ({ title, content, logoImage, link, font }) => {
    return (
        <Flex
            alignItems={'flex-start'}
            justifyContent={'space-between'}
            flexDirection={'column'}
            padding={'2.8125rem 1.875rem'}
            bg="dark.1"
        >
            <Flex flexDirection={'column'}>
                <Heading
                    as={'h3'}
                    fontWeight={'600'}
                    fontSize={{
                        base: font === 'smaller' ? '21px' : '1.625rem',
                    }}
                    lineHeight={{ base: font === 'smaller' ? '31.5px' : '2.125rem' }}
                    variant={'label'}
                    marginBottom={'1.25rem'}
                    textAlign={'left'}
                >
                    {title}
                </Heading>
                <Box
                    width={'1.875rem'}
                    height={'0.1875rem'}
                    background={'black'}
                    marginBottom={content ? '1.875rem' : '0'}
                />
                {content && (
                    <Text size={'xl'} marginBottom={'1.25rem'}>
                        {content}
                    </Text>
                )}
            </Flex>
            {link && (
                <Flex flexDirection={'column'}>
                    {/* TODO Stworzyć link w chakra ui */}
                    <StyledLink href={link.href} target={link.target}>
                        {link.label}
                    </StyledLink>
                </Flex>
            )}
            {logoImage && <img src={logoImage.url} alt={logoImage.alt}></img>}
        </Flex>
    );
};

export default TileItem;
